import axios from 'axios';
import { ApolloClient } from '@apollo/client';
import gql from 'graphql-tag';

export type QuizModeratorActionPayload = {
  presentationId: string;
  action: string;
  question_index: number;
};

const UPDATE_QUIZ_ACTION = gql`
  mutation UpdateQuizAction(
    $presentation_id: String!
    $action: String!
    $question_index: Int!
  ) {
    update_quiz_actions(
      where: { presentation_id: { _eq: $presentation_id } }
      _set: { action: $action, question_index: $question_index }
    ) {
      affected_rows
    }
  }
`;

/** Persist quiz action to Hasura and notify clients via the socket API. */
export async function syncQuizModeratorAction(
  apolloClient: ApolloClient<unknown> | null,
  payload: QuizModeratorActionPayload
): Promise<void> {
  const questionIndex = Number(payload.question_index);

  const tasks: Promise<unknown>[] = [
    axios.post(
      `${process.env.REACT_APP_SOCKET_URL}/quiz-moderator-action-change`,
      {
        presentationId: payload.presentationId,
        action: payload.action,
        question_index: questionIndex,
      },
      { headers: { 'Content-Type': 'application/json' } }
    ),
  ];

  if (apolloClient) {
    tasks.push(
      apolloClient.mutate({
        mutation: UPDATE_QUIZ_ACTION,
        variables: {
          presentation_id: payload.presentationId,
          action: payload.action,
          question_index: questionIndex,
        },
      })
    );
  }

  await Promise.allSettled(tasks);
}
